import type { MobileStore } from './installBanner';

/**
 * Официальные бейджи сторов — файлы и их собственные пропорции.
 *
 * Лежат отдельно, потому что их показывают два места: блок «Agapella всегда
 * рядом» на главной и страница `/download`, куда ведёт QR (CORE-1548). Высоту
 * задаёт вызывающий, ширина считается из пропорции — растягивать официальный
 * бейдж нельзя.
 */
export const STORE_BADGE: Record<MobileStore, { src: string; aspect: number }> = {
  ios: { src: '/badges/app-store-ru.svg', aspect: 119.66407 / 40 },
  android: { src: '/badges/google-play-ru.png', aspect: 646 / 192 },
};
